<template>
  <div id="problemCenter">
    <div class="problemBox">
      <div style="width:100%;height:100%;overflow-y: auto;">
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="problemList"
          stripe
          height="calc(100% - 20px - 50px)"
          style="width: 100%; margin-top:20px"
        >
          <el-table-column prop="content" :show-overflow-tooltip="true" align="center" label="提交内容"></el-table-column>

          <el-table-column
            prop="show_time"
            :show-overflow-tooltip="true"
            align="center"
            label="提交时间"
          ></el-table-column>

          <el-table-column
            prop="username"
            :show-overflow-tooltip="true"
            align="show_time"
            label="提交时间"
          >
            <template slot-scope="scope">
              <div>
                <img v-for="item in scope.row.annex_json" :src="item" alt />
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="address" width="300" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="isAdmin1==0 ? false : true"
                @click="handleEditUser(scope.row)"
                class="tableBtn"
              >编辑</el-button>
              <el-button
                :disabled="isAdmin1==0 ? false : true"
                @click="handleRemoveUser(scope.row)"
                class="tableBtn"
                style="    border-color: #999999;color: #666666;"
              >删除</el-button>
            </template>
          </el-table-column>-->
        </el-table>
        <!-- <div class="pageRow" v-if="problemList.length>0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            background
            :page-sizes="[5, 10, 15, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="Total"
          ></el-pagination>
        </div>-->
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'helpCenter',
  data() {
    return {
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      problemList: [],
      currentPage: 1,
      pageSize: 10,
      Total: 0,
    }
  },

  methods: {
    // *获取使用帮助详情
    async getProblemList(id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Help/problem_list',
        data: param,
      })
      if (res.code != 200) {
        return this.$message.error(res.datas.msg)
      }
      this.problemList = res.datas.list
      console.log('问题列表', this.problemList)
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
  },
  activated() {},
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProblemList()
  },
  watch: {},
}
</script>
<style lang="less" scoped>
#problemCenter {
  box-sizing: border-box;
  padding: 30px;
  height: 100%;
  .problemBox {
    border-radius: 10px;
    box-shadow: 1px 5px 9px 0px rgb(3 70 126 / 14%);
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 30px;
  }
}
</style>
